import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { palette } from 'styled-theme';

export const Wrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const FooterLink = styled(Link)`
  margin-left: 20px;
  font-family: Helvetica;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  text-decoration: none;
  color: ${palette('secondary', 0)} !important;

  &:first-child {
    margin-left: 0;
  }
`;

export const LinksContainer = styled('div')`
  display: flex;
  align-items: center;
`;

// Cookie settings reopens the OneTrust preference centre rather than navigating, so it is a
// button for keyboard and screen-reader users, styled to sit alongside the footer links.
// Spacing comes from `.link-container:not(:first-child)` on the wrapper, so no margin here —
// FooterLink only carries one because it zeroes it again via `:first-child`.
export const FooterButton = styled('button')`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: Helvetica;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  text-decoration: none;
  color: ${palette('secondary', 0)} !important;
`;
